import React from 'react';

export type IconProps = {
  color?: string;
  className?: string;
  size?: string | number;
};

export const XCircleIcon_inactive = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="x-circle-inactive"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

export const OpenOnNewPage = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="open-on-new-page"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  );
};

export const XCircleIcon_active = ({ color = 'DarkRed' }: IconProps) => {
  return (
    <svg
      id="x-circle-active"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
    >
      <path
        fillRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const CheckIcon_inactive = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="check-icon-inactive"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
    >
      <path
        fillRule="evenodd"
        d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const CheckIcon_active = ({ color = 'ForestGreen' }: IconProps) => {
  return (
    <svg
      id="check-icon-active"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
    >
      <path
        fillRule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const FavoriteIcon_inactive = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="favorite-icon-inactive"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
      />
    </svg>
  );
};

export const FavoriteIcon_active = ({ color = 'Red' }: IconProps) => {
  return (
    <svg
      id="favorite-icon-active"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
    >
      <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
    </svg>
  );
};

export const MapIcon_heart = ({ color = 'Red' }: IconProps) => {
  return (
    <svg
      id="map-icon-heart"
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      viewBox="-2 -2 22 22"
    >
      <path
        fill="white"
        className="drop-shadow"
        d="M 5.27,0.00
          C 5.27,0.00 5.27,0.00 5.27,0.00 3.82,0.00 2.50,0.65 1.54,1.69 0.59,2.73 -0.00,4.17 -0.00,5.77 -0.00,7.36 0.59,8.80 1.54,9.84 1.54,9.84 5.27,13.92 5.27,13.92 5.27,13.92 9.00,18.00 9.00,18.00 9.00,18.00 12.73,13.92 12.73,13.92 12.73,13.92 16.46,9.84 16.46,9.84 17.41,8.80 18.00,7.36 18.00,5.77 18.00,4.17 17.41,2.73 16.46,1.69 15.50,0.65 14.18,0.00 12.73,0.00 11.27,0.00 9.95,0.65 9.00,1.69 8.05,0.65 6.73,0.00 5.27,0.00 5.27,0.00 5.27,0.00 5.27,0.00 Z"
      />
      <path
        fill={color}
        d="M 6.20,2.03
          C 6.20,2.03 6.20,2.03 6.20,2.03 5.11,2.03 4.12,2.51 3.41,3.29 2.69,4.06 2.25,5.13 2.25,6.31 2.25,7.49 2.69,8.56 3.41,9.34 3.41,9.34 6.20,12.36 6.20,12.36 6.20,12.36 9.00,15.38 9.00,15.38 9.00,15.38 11.80,12.36 11.80,12.36 11.80,12.36 14.59,9.34 14.59,9.34 15.31,8.56 15.75,7.49 15.75,6.31 15.75,5.13 15.31,4.06 14.59,3.29 13.88,2.51 12.89,2.03 11.80,2.03 10.70,2.03 9.72,2.51 9.00,3.29 8.28,2.51 7.30,2.03 6.20,2.03 6.20,2.03 6.20,2.03 6.20,2.03 Z"
      ></path>
    </svg>
  );
};

export const MinusIcon = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="minus-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className="w-6 h-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
    </svg>
  );
};
export const CircleMinusIcon = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="minus-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  );
};

export const IconHouse = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      id="icon-house"
      viewBox="0 0 16 16"
      height="1em"
      width="1em"
      fill={color}
    >
      <path
        fillRule="evenodd"
        d="M2 13.5V7h1v6.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V7h1v6.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 13.5zm11-11V6l-2-2V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z"
      />
      <path
        fillRule="evenodd"
        d="M7.293 1.5a1 1 0 011.414 0l6.647 6.646a.5.5 0 01-.708.708L8 2.207 1.354 8.854a.5.5 0 11-.708-.708L7.293 1.5z"
      />
    </svg>
  );
};

export const IconHouseFill = ({ color = 'Black', ...rest }: IconProps) => {
  return (
    <svg
      id="icon-house-fill"
      className="fill-blue h-4 w-4"
      viewBox="0 0 16 16"
      fill={color}
      {...rest}
    >
      <path
        fillRule="evenodd"
        d="M8 3.293l6 6V13.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z"
      />
      <path
        fillRule="evenodd"
        d="M7.293 1.5a1 1 0 011.414 0l6.647 6.646a.5.5 0 01-.708.708L8 2.207 1.354 8.854a.5.5 0 11-.708-.708L7.293 1.5z"
      />
    </svg>
  );
};

export const ArrowIcon = ({ className = '', color = 'white' }) => {
  return (
    <svg
      id="arrow-icon"
      className={` stroke-[.5] ${className}`}
      fillOpacity={0}
      strokeLinecap="round"
      viewBox="0 0 4 8"
      stroke={color}
    >
      <defs>
        <filter
          id="outline"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="userSpaceOnUse"
        >
          <feDropShadow dx={0} dy={0} stdDeviation={0.5} floodColor="black" />
        </filter>
      </defs>
      <path filter="url(#outline)" d="M 1 1 L 3 4 L 1 7" />
    </svg>
  );
};
export const ArrowIconSizeable = ({
  className = '',
  color = 'black',
  width = '12px',
  height = '24px',
}) => {
  return (
    <svg
      id="arrow-icon"
      className={` stroke-[.5] ${className}`}
      fillOpacity={0}
      strokeLinecap="round"
      viewBox="0 0 4 8"
      stroke={color}
      width={width}
      height={height}
    >
      <path className="drop-shadow-md" d="M 1 1 L 3 4 L 1 7" />
    </svg>
  );
};
export const LoadingSpinner = ({ color = 'Black', size = '8' }: IconProps) => {
  return (
    <svg
      id="loading-spinner"
      aria-hidden="true"
      className={`inline w-${size} h-${size} text-gray-200 animate-spin dark:text-gray-600 fill-purple-600`}
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="Black"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
  );
};

export const Loader = ({ width = null, height = null }) => {
  if (width && height) {
    return (
      <svg
        id="loader"
        className="stroke-indigo-600 stroke-opacity-90 animate-spin"
        fillOpacity={0}
        viewBox="0 0 10 10"
        width={width}
        height={height}
      >
        <path d="M 5 1 C 3 1 1 3 1 5 M 5 9 C 7 9 9 7 9 5" />
      </svg>
    );
  }
  return (
    <svg
      className="stroke-indigo-600/90 animate-spin"
      fillOpacity={0}
      viewBox="0 0 10 10"
    >
      <path d="M 5 1 C 3 1 1 3 1 5 M 5 9 C 7 9 9 7 9 5" />
    </svg>
  );
};

export const CloseIcon = ({ width = 10, height = 10 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26">
      <path
        style={{ fill: '#030104' }}
        d="M21.125,0H4.875C2.182,0,0,2.182,0,4.875v16.25C0,23.818,2.182,26,4.875,26h16.25
        C23.818,26,26,23.818,26,21.125V4.875C26,2.182,23.818,0,21.125,0z M18.78,17.394l-1.388,1.387c-0.254,0.255-0.67,0.255-0.924,0
        L13,15.313L9.533,18.78c-0.255,0.255-0.67,0.255-0.925-0.002L7.22,17.394c-0.253-0.256-0.253-0.669,0-0.926l3.468-3.467
        L7.221,9.534c-0.254-0.256-0.254-0.672,0-0.925l1.388-1.388c0.255-0.257,0.671-0.257,0.925,0L13,10.689l3.468-3.468
        c0.255-0.257,0.671-0.257,0.924,0l1.388,1.386c0.254,0.255,0.254,0.671,0.001,0.927l-3.468,3.467l3.468,3.467
        C19.033,16.725,19.033,17.138,18.78,17.394z"
      />
    </svg>
  );
};

export const TrashIcon = ({ width = 10, height = 10 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="Black"
      width={width}
      height={height}
    >
      <path d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
    </svg>
  );
};

export const Unsorted = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className="p-icon p-sortable-column-icon ml-2 text-slate-700 dark:text-white/70"
      aria-hidden="true"
      data-pc-section="sorticon"
    >
      <path
        d="M5.64515 3.61291C5.47353 3.61291 5.30192 3.54968 5.16644 3.4142L3.38708 1.63484L1.60773 3.4142C1.34579 3.67613 0.912244 3.67613 0.650309 3.4142C0.388374 3.15226 0.388374 2.71871 0.650309 2.45678L2.90837 0.198712C3.17031 -0.0632236 3.60386 -0.0632236 3.86579 0.198712L6.12386 2.45678C6.38579 2.71871 6.38579 3.15226 6.12386 3.4142C5.98837 3.54968 5.81676 3.61291 5.64515 3.61291Z"
        fill="Black"
      ></path>
      <path
        d="M3.38714 14C3.01681 14 2.70972 13.6929 2.70972 13.3226V0.677419C2.70972 0.307097 3.01681 0 3.38714 0C3.75746 0 4.06456 0.307097 4.06456 0.677419V13.3226C4.06456 13.6929 3.75746 14 3.38714 14Z"
        fill="Black"
      ></path>
      <path
        d="M10.6129 14C10.4413 14 10.2697 13.9368 10.1342 13.8013L7.87611 11.5432C7.61418 11.2813 7.61418 10.8477 7.87611 10.5858C8.13805 10.3239 8.5716 10.3239 8.83353 10.5858L10.6129 12.3652L12.3922 10.5858C12.6542 10.3239 13.0877 10.3239 13.3497 10.5858C13.6116 10.8477 13.6116 11.2813 13.3497 11.5432L11.0916 13.8013C10.9561 13.9368 10.7845 14 10.6129 14Z"
        fill="Black"
      ></path>
      <path
        d="M10.6129 14C10.2426 14 9.93552 13.6929 9.93552 13.3226V0.677419C9.93552 0.307097 10.2426 0 10.6129 0C10.9833 0 11.2904 0.307097 11.2904 0.677419V13.3226C11.2904 13.6929 10.9832 14 10.6129 14Z"
        fill="Black"
      ></path>
    </svg>
  );
};

export const SortAscending = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={color}
      stroke={'#2a89ff'}
      xmlns="http://www.w3.org/2000/svg"
      className="p-icon p-sortable-column-icon ml-2 text-blue-700 dark:text-white/80"
      aria-hidden="true"
      data-pc-section="sorticon"
    >
      <path
        d="M4.59864 3.99958C4.44662 3.99958 4.2946 3.94357 4.17458 3.82356L2.59836 2.24734L1.02214 3.82356C0.79011 4.05559 0.406057 4.05559 0.174024 3.82356C-0.0580081 3.59152 -0.0580081 3.20747 0.174024 2.97544L2.1743 0.97516C2.40634 0.743127 2.79039 0.743127 3.02242 0.97516L5.0227 2.97544C5.25473 3.20747 5.25473 3.59152 5.0227 3.82356C4.90268 3.94357 4.75066 3.99958 4.59864 3.99958Z"
        fill="Black"
      ></path>
      <path
        d="M2.59841 13.2009C2.27036 13.2009 1.99833 12.9288 1.99833 12.6008V1.39922C1.99833 1.07117 2.27036 0.799133 2.59841 0.799133C2.92646 0.799133 3.19849 1.07117 3.19849 1.39922V12.6008C3.19849 12.9288 2.92646 13.2009 2.59841 13.2009Z"
        fill="Black"
      ></path>
      <path
        d="M13.3999 11.2006H6.99902C6.67098 11.2006 6.39894 10.9285 6.39894 10.6005C6.39894 10.2725 6.67098 10.0004 6.99902 10.0004H13.3999C13.728 10.0004 14 10.2725 14 10.6005C14 10.9285 13.728 11.2006 13.3999 11.2006Z"
        fill="Black"
      ></path>
      <path
        d="M10.1995 6.39991H6.99902C6.67098 6.39991 6.39894 6.12788 6.39894 5.79983C6.39894 5.47179 6.67098 5.19975 6.99902 5.19975H10.1995C10.5275 5.19975 10.7996 5.47179 10.7996 5.79983C10.7996 6.12788 10.5275 6.39991 10.1995 6.39991Z"
        fill="Black"
      ></path>
      <path
        d="M8.59925 3.99958H6.99902C6.67098 3.99958 6.39894 3.72754 6.39894 3.3995C6.39894 3.07145 6.67098 2.79941 6.99902 2.79941H8.59925C8.92729 2.79941 9.19933 3.07145 9.19933 3.3995C9.19933 3.72754 8.92729 3.99958 8.59925 3.99958Z"
        fill="Black"
      ></path>
      <path
        d="M11.7997 8.80025H6.99902C6.67098 8.80025 6.39894 8.52821 6.39894 8.20017C6.39894 7.87212 6.67098 7.60008 6.99902 7.60008H11.7997C12.1277 7.60008 12.3998 7.87212 12.3998 8.20017C12.3998 8.52821 12.1277 8.80025 11.7997 8.80025Z"
        fill="Black"
      ></path>
    </svg>
  );
};

export const SortDescending = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke={'#2a89ff'}
      xmlns="http://www.w3.org/2000/svg"
      className="p-icon p-sortable-column-icon ml-2 text-blue-700 dark:text-white/80"
      aria-hidden="true"
      data-pc-section="sorticon"
    >
      <path
        d="M2.59836 13.2009C2.44634 13.2009 2.29432 13.1449 2.1743 13.0248L0.174024 11.0246C-0.0580081 10.7925 -0.0580081 10.4085 0.174024 10.1764C0.406057 9.94441 0.79011 9.94441 1.02214 10.1764L2.59836 11.7527L4.17458 10.1764C4.40662 9.94441 4.79067 9.94441 5.0227 10.1764C5.25473 10.4085 5.25473 10.7925 5.0227 11.0246L3.02242 13.0248C2.90241 13.1449 2.75038 13.2009 2.59836 13.2009Z"
        fill="Black"
      ></path>
      <path
        d="M2.59836 13.2009C2.27032 13.2009 1.99833 12.9288 1.99833 12.6008V1.39922C1.99833 1.07117 2.27036 0.799133 2.59841 0.799133C2.92646 0.799133 3.19849 1.07117 3.19849 1.39922V12.6008C3.19849 12.9288 2.92641 13.2009 2.59836 13.2009Z"
        fill="Black"
      ></path>
      <path
        d="M13.3999 11.2006H6.99902C6.67098 11.2006 6.39894 10.9285 6.39894 10.6005C6.39894 10.2725 6.67098 10.0004 6.99902 10.0004H13.3999C13.728 10.0004 14 10.2725 14 10.6005C14 10.9285 13.728 11.2006 13.3999 11.2006Z"
        fill="Black"
      ></path>
      <path
        d="M10.1995 6.39991H6.99902C6.67098 6.39991 6.39894 6.12788 6.39894 5.79983C6.39894 5.47179 6.67098 5.19975 6.99902 5.19975H10.1995C10.5275 5.19975 10.7996 5.47179 10.7996 5.79983C10.7996 6.12788 10.5275 6.39991 10.1995 6.39991Z"
        fill="Black"
      ></path>
      <path
        d="M8.59925 3.99958H6.99902C6.67098 3.99958 6.39894 3.72754 6.39894 3.3995C6.39894 3.07145 6.67098 2.79941 6.99902 2.79941H8.59925C8.92729 2.79941 9.19933 3.07145 9.19933 3.3995C9.19933 3.72754 8.92729 3.99958 8.59925 3.99958Z"
        fill="Black"
      ></path>
      <path
        d="M11.7997 8.80025H6.99902C6.67098 8.80025 6.39894 8.52821 6.39894 8.20017C6.39894 7.87212 6.67098 7.60008 6.99902 7.60008H11.7997C12.1277 7.60008 12.3998 7.87212 12.3998 8.20017C12.3998 8.52821 12.1277 8.80025 11.7997 8.80025Z"
        fill="Black"
      ></path>
    </svg>
  );
};

export const IconX = ({ color = 'Black' }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      stroke="Black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-x"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M18 6l-12 12" />
      <path d="M6 6l12 12" />
    </svg>
  );
};

export const RedCheckMark = ({ width = 10, height = 10 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="red"
      height={height}
      width={width}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 12.75 6 6 9-13.5"
      />
    </svg>
  );
};

export const SplitIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      className="h-5 w-5 stroke-[1.5] text-current"
      fill="currentColor"
    >
      <path d="M2.00021 18C1.45021 18 0.980209 17.804 0.587209 17.413C0.398023 17.2301 0.248332 17.0103 0.147373 16.7673C0.0464137 16.5243 -0.0036711 16.2631 0.000209424 16V2C0.000209424 1.45 0.196209 0.979996 0.587209 0.586996C0.770136 0.39781 0.989893 0.248118 1.23292 0.147159C1.47594 0.0462 1.73708 -0.00388473 2.00021 -4.1988e-06H16.0002C16.5502 -4.1988e-06 17.0202 0.195996 17.4132 0.586996C17.8032 0.979996 18.0002 1.45 18.0002 2V16C18.0002 16.55 17.8042 17.02 17.4132 17.413C17.2303 17.6022 17.0105 17.7519 16.7675 17.8528C16.5245 17.9538 16.2633 18.0039 16.0002 18H2.00021ZM5.00021 16V2H2.00021V16H5.00021ZM7.00021 16H16.0002V2H7.00021V16Z" />
    </svg>
  );
};

export const HandDraw = ({ size = 24 }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46664 4.742C8.3971 4.4869 8.22935 4.26972 8.00011 4.13798C7.77086 4.00623 7.49876 3.97064 7.24334 4.03899C6.98792 4.10735 6.76996 4.27407 6.63715 4.5027C6.50434 4.73134 6.46748 5.00326 6.53464 5.259L9.13864 14.974C9.19015 15.1651 9.18378 15.3673 9.12033 15.5548C9.05689 15.7423 8.93922 15.9067 8.78223 16.0273C8.62524 16.1479 8.436 16.2192 8.23847 16.2321C8.04094 16.245 7.84402 16.1991 7.67264 16.1L6.00064 15.134C5.88687 15.0673 5.76103 15.0238 5.63036 15.0059C5.4997 14.988 5.36679 14.9962 5.23929 15.0299C5.11179 15.0636 4.99222 15.1222 4.88746 15.2023C4.7827 15.2824 4.69482 15.3825 4.62887 15.4967C4.56293 15.6109 4.52023 15.737 4.50323 15.8678C4.48624 15.9986 4.49527 16.1314 4.52983 16.2587C4.56438 16.386 4.62377 16.5051 4.70457 16.6094C4.78537 16.7136 4.88599 16.8008 5.00064 16.866L9.93264 19.714C10.2576 19.901 10.6256 20 11.0006 20C11.2659 20 11.5202 20.1054 11.7077 20.2929C11.8953 20.4804 12.0006 20.7348 12.0006 21C12.0006 21.2652 11.8953 21.5196 11.7077 21.7071C11.5202 21.8946 11.2659 22 11.0006 22C10.2746 22.0001 9.56138 21.809 8.93264 21.446L4.00064 18.598C3.34524 18.2198 2.85696 17.6079 2.63364 16.885C2.41031 16.162 2.46844 15.3813 2.79638 14.6994C3.12432 14.0175 3.69784 13.4846 4.40202 13.2077C5.1062 12.9308 5.88902 12.9302 6.59364 13.206L4.60364 5.777C4.40943 5.01243 4.52418 4.20213 4.92304 3.52155C5.3219 2.84097 5.97277 2.34487 6.73473 2.14068C7.4967 1.93648 8.30842 2.04061 8.99417 2.43053C9.67991 2.82045 10.1845 3.46478 10.3986 4.224L11.4106 8H16.6256C17.5064 8.00001 18.3625 8.29071 19.0612 8.827C19.7598 9.36329 20.262 10.1152 20.4896 10.966L20.8326 12.249C21.6257 15.2131 21.3448 18.3621 20.0396 21.139L19.9056 21.425C19.8514 21.5463 19.7735 21.6556 19.6766 21.7465C19.5796 21.8374 19.4655 21.9081 19.3409 21.9543C19.2164 22.0006 19.0838 22.0216 18.951 22.0161C18.8182 22.0105 18.6879 21.9786 18.5676 21.9221C18.4473 21.8656 18.3395 21.7857 18.2504 21.6871C18.1614 21.5884 18.0929 21.473 18.0489 21.3476C18.005 21.2222 17.9865 21.0892 17.9945 20.9566C18.0025 20.8239 18.0369 20.6942 18.0956 20.575L18.2296 20.289C19.3342 17.9391 19.5719 15.2743 18.9006 12.766L18.5576 11.483C18.4438 11.0576 18.1927 10.6816 17.8434 10.4135C17.4941 10.1454 17.066 10 16.6256 10H11.9456L12.1456 10.741C12.1797 10.8679 12.1883 11.0002 12.1712 11.1304C12.1541 11.2606 12.1115 11.3862 12.0458 11.4999C11.9802 11.6137 11.8928 11.7134 11.7886 11.7934C11.6844 11.8733 11.5655 11.932 11.4386 11.966C11.1824 12.0347 10.9094 11.9988 10.6797 11.8662C10.566 11.8006 10.4663 11.7131 10.3863 11.609C10.3063 11.5048 10.2476 11.3859 10.2136 11.259L8.46664 4.742ZM12.0006 3C12.0006 2.73478 12.106 2.48043 12.2935 2.29289C12.4811 2.10536 12.7354 2 13.0006 2C16.0646 2 18.9516 2.766 21.4796 4.118C21.7136 4.24318 21.8882 4.45616 21.9651 4.71009C22.0419 4.96401 22.0148 5.23808 21.8896 5.472C21.7645 5.70592 21.5515 5.88053 21.2976 5.95742C21.0436 6.03431 20.7696 6.00718 20.5356 5.882C18.2178 4.64244 15.6291 3.99588 13.0006 4C12.7354 4 12.4811 3.89464 12.2935 3.70711C12.106 3.51957 12.0006 3.26522 12.0006 3Z"
        fill="black"
      />
    </svg>
  );
};

export const Layers = ({ size = 24 }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill="white" />
      <path
        d="M11.9988 20.525C11.7818 20.525 11.5698 20.488 11.3618 20.413C11.152 20.3371 10.954 20.2317 10.7738 20.1L4.02383 14.85C3.89783 14.7623 3.7962 14.6439 3.72851 14.506C3.66081 14.3682 3.62927 14.2154 3.63683 14.062C3.63786 13.9075 3.67578 13.7555 3.74744 13.6186C3.81911 13.4817 3.92244 13.3639 4.04883 13.275C4.22186 13.1451 4.43242 13.0748 4.64883 13.0748C4.86524 13.0748 5.0758 13.1451 5.24883 13.275L11.9988 18.5L18.7488 13.275C18.9219 13.1451 19.1324 13.0748 19.3488 13.0748C19.5652 13.0748 19.7758 13.1451 19.9488 13.275C20.2158 13.475 20.3528 13.737 20.3618 14.062C20.369 14.2155 20.3372 14.3682 20.2693 14.506C20.2015 14.6438 20.0998 14.7622 19.9738 14.85L13.2238 20.1C13.0439 20.2316 12.8463 20.3369 12.6368 20.413C12.4322 20.487 12.2164 20.5249 11.9988 20.525ZM11.9988 15.475C11.7818 15.475 11.5698 15.438 11.3618 15.363C11.152 15.2871 10.954 15.1817 10.7738 15.05L4.02383 9.80004C3.89546 9.70601 3.79238 9.58164 3.72383 9.43804C3.65876 9.30119 3.625 9.15157 3.625 9.00004C3.625 8.84851 3.65876 8.69889 3.72383 8.56204C3.79238 8.41844 3.89546 8.29407 4.02383 8.20004L10.7738 2.95004C10.9568 2.81704 11.1538 2.71204 11.3618 2.63704C11.7737 2.48785 12.2249 2.48785 12.6368 2.63704C12.8448 2.71204 13.0408 2.81704 13.2238 2.95004L19.9738 8.20004C20.1068 8.30004 20.2068 8.42004 20.2738 8.56204C20.3389 8.69889 20.3727 8.84851 20.3727 9.00004C20.3727 9.15157 20.3389 9.30119 20.2738 9.43804C20.2053 9.58164 20.1022 9.70601 19.9738 9.80004L13.2238 15.05C13.0439 15.1816 12.8463 15.2869 12.6368 15.363C12.4322 15.437 12.2164 15.4749 11.9988 15.475ZM11.9988 13.45L17.7488 9.00004L11.9988 4.55004L6.24883 9.00004L11.9988 13.45Z"
        fill="black"
      />
    </svg>
  );
};

export const CloseIconDualBorder = ({ size = 24 }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      style={{ fill: '#1A1A1A' }}
    >
      <path d="M 11.480469 5.0058594 C 10.500482 5.0058442 9.521297 5.3771405 8.7792969 6.1191406 L 6.1191406 8.7792969 C 4.6346201 10.26247 4.6351404 12.69764 6.1191406 14.181641 L 15.9375 24 L 6.1191406 33.818359 C 4.6346201 35.301533 4.6351404 37.736703 6.1191406 39.220703 L 8.7792969 41.880859 C 10.26247 43.36538 12.69764 43.36486 14.181641 41.880859 L 24 32.0625 L 33.818359 41.880859 C 35.301533 43.36538 37.736703 43.36486 39.220703 41.880859 L 41.880859 39.220703 C 43.36538 37.73753 43.36486 35.30236 41.880859 33.818359 L 32.0625 24 L 41.880859 14.181641 C 43.36538 12.698467 43.36486 10.263297 41.880859 8.7792969 L 39.220703 6.1191406 C 37.73753 4.6346201 35.30236 4.6351404 33.818359 6.1191406 L 24 15.9375 L 14.181641 6.1191406 C 13.440054 5.3768804 12.460456 5.0058746 11.480469 5.0058594 z M 11.480469 6.9921875 C 11.944232 6.9921723 12.408165 7.1734634 12.767578 7.5332031 L 23.292969 18.058594 A 1.0001 1.0001 0 0 0 24.707031 18.058594 L 35.232422 7.5332031 C 35.952422 6.8132033 37.087814 6.8137237 37.806641 7.5332031 L 40.466797 10.193359 C 41.186797 10.913359 41.186276 12.048752 40.466797 12.767578 L 29.941406 23.292969 A 1.0001 1.0001 0 0 0 29.941406 24.707031 L 40.466797 35.232422 C 41.186797 35.952422 41.186276 37.087814 40.466797 37.806641 L 37.806641 40.466797 C 37.086641 41.186797 35.951248 41.186276 35.232422 40.466797 L 24.707031 29.941406 A 1.0001 1.0001 0 0 0 23.292969 29.941406 L 12.767578 40.466797 C 12.047578 41.186797 10.912186 41.186276 10.193359 40.466797 L 7.5332031 37.806641 C 6.8132033 37.086641 6.8137237 35.951248 7.5332031 35.232422 L 18.058594 24.707031 A 1.0001 1.0001 0 0 0 18.058594 23.292969 L 7.5332031 12.767578 C 6.8132033 12.047578 6.8137237 10.912186 7.5332031 10.193359 L 10.193359 7.5332031 C 10.553359 7.1732032 11.016706 6.9922027 11.480469 6.9921875 z"></path>
    </svg>
  );
};

export const ChevronDown = ({ size = 24, color = 'white' }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 0 0 L 24 0 l -12 24 L 0 0" />
    </svg>
  );
};
